import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { getSettingFactory } from "@faire/web--source/common/SerializedSetting";
var _getSettingFactory = getSettingFactory(function() {
    return getGlobalProperty("settingsValues", {});
}), getSettingValueWithoutAssignment = _getSettingFactory.getSettingValueWithoutAssignment, getSettingValueAndAssign = _getSettingFactory.getSettingValueAndAssign, assignSetting = _getSettingFactory.assignSetting;
export { assignSetting, getSettingValueAndAssign, getSettingValueWithoutAssignment };
